import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4 {...{
      "id": "segment-browser-or-mobile-libraries"
    }}>{`Segment browser or mobile libraries`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Capturing an event with groups
analytics.track('[event name]', {
    "$groups": {
        "company": "id:5"
    }
})

// Updating group properties
analytics.track('$groupidentify', {
    "$group_type": "company",
    "$group_key": "id:5",
    "$group_set": {
        "company_name": "Awesome Inc",
        "employees": 11
    }
})
`}</code></pre>
    <h4 {...{
      "id": "segment-backend-libraries"
    }}>{`Segment backend libraries`}</h4>
    <p>{`For backend libraries you need to send a distinct id (as with any other .track call).`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`# Capturing an event with groups
analytics.track('distinct_id', '[event name]', {
    "$groups": {
        "company": "id:5"
    }
})

# Updating group properties
analytics.track('distinct_id', '$groupidentify', {
    "$group_type": "company",
    "$group_key": "id:5",
    "$group_set": {
        "company_name": "Awesome Inc",
        "employees": 11
    }
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      